export default __webpack_public_path__ + "static/media/Jerkin of Vernant Fury.8a038d65.jpg";